import { TRepair } from '@cian/api-models/offer-card/v1/get-offer-data';

export function getRepairType(repairType: TRepair | null) {
  const mapRepairTypeToRepairTypeQueryValue: { [key: string]: string } = {
    cosmetic: 'repairTypeCosmetic',
    design: 'repairTypeDesign',
    euro: 'repairTypeEuro',
    no: 'repairTypeWithout',
  };

  if (!repairType) {
    return null;
  }

  return `repairType=${mapRepairTypeToRepairTypeQueryValue[repairType]}`;
}
